module.exports = __webpack_public_path__ + "media/images/brand_icons/icon_clubpilates-c255f4984f33e4e41d83328132803ef4.svg";